export default __webpack_public_path__ + "static/media/LogoKahshComCirculo.12924e44.svg";